<template>
  <section class="settings-container">
    <header class="page-header">
      <h1>Settings</h1>
    </header>
    <section class="embed-responsive embed-responsive-16by9">
      <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/qpXyZu0Ydfc?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </section>
    <br>
    General:
    <ul>
      <li><router-link to="/settings/general/hand-rankings">Hand rankings</router-link></li>
      <li><router-link to="/settings/general/saved-ranges">Saved ranges</router-link></li>
      <li><router-link to="/settings/general/tiers">Tiers</router-link></li>
      <li><router-link to="/settings/general/included-selectors">Included selectors</router-link></li>
      <li><router-link to="/settings/general/visual">Visual</router-link></li>
    </ul>
    Equity calculator:
    <ul>
      <li><router-link to="/settings/equity-calculator/rake-and-tip">Rake and tip</router-link></li>
      <li><router-link to="/settings/equity-calculator/number-of-simulations">Number of simulations</router-link></li>
      <!-- <li><router-link to="/settings/equity-calculator/insights">Insights</router-link></li> -->
    </ul>
    Hit calculator:
    <ul>
      <li>
        Checkboxes:
        <ul>
          <li><router-link to="/settings/hit-calculator/checkboxes/included">Included</router-link></li>
          <li><router-link to="/settings/hit-calculator/checkboxes/collapsed-by-default">Collapsed by default</router-link></li>
          <li><router-link to="/settings/hit-calculator/checkboxes/filters">Filters</router-link></li>
        </ul>
      </li>
      <li><router-link to="/settings/hit-calculator/number-of-simulations">Number of simulations</router-link></li>
      <li><router-link to="/settings/hit-calculator/insights">Insights</router-link></li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'ppt-settings',
};
</script>

<style lang="scss" scoped>
  .settings-container {
    font-size: 18px;

    @media (max-device-width: 768px) {
      li {
        margin-bottom: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/settings.vue